import CHROME_LOGO from '@public/assets/chrome_logo.svg'
import EDGE_LOGO from '@public/assets/edge_logo.svg'

import type { SettingsSource } from './types'

export const MIRA_TAB_INDEX = 0
export const DESKTOP_AGENT_TAB_INDEX = 1
export const SOURCE_TAB_OFFSET = 2
export const INSTALLER_NAME = 'MIRAInstaller'
export const DEFAULT_INSTALLER_FILENAME = 'MIRAInstaller.zip'
export const MAX_CUSTOM_NARRATIVE_PREFERENCES = 2
// MIRA-4181: Allow longer custom narrative instructions.
export const MAX_NARRATIVE_PREFERENCE_WORDS = 100

export const EXCLUSION_GRID_ROW_HEIGHT = 50
export const EXCLUSION_GRID_PAGE_SIZE = 40
export const EXCLUSION_GRID_CELL_CLASS = 'box-border h-[50px] py-0 align-middle'
export const EXCLUSION_GRID_CLASS =
  '[&_.k-grid]:border-0 [&_.k-grid_table]:[border-spacing:0] [&_.k-grid-header]:border-0 [&_.k-grid-header]:p-0 [&_.k-grid-header-wrap]:border-0 [&_.k-header]:border-0 [&_.k-column-title]:text-xs [&_.k-column-title]:font-normal [&_.k-column-title]:text-[#525252] [&_td]:text-sm [&_td]:font-normal [&_td]:text-[#333] [&_.k-grid_th]:h-[50px] [&_.k-grid_th]:!border-b-0 [&_.k-grid_th]:leading-[50px] [&_.k-grid_tr]:h-[50px] [&_.k-grid_tr]:border-b [&_.k-grid_tr]:border-[#ebebeb] [&_.k-grid_td]:box-border [&_.k-grid_td]:h-[50px] [&_.k-grid_td]:py-0 [&_.k-grid_td]:align-middle'

export const SETTINGS_SOURCES: SettingsSource[] = [
  {
    orderBy: 1,
    key: 'chrome',
    icon: CHROME_LOGO,
    label: 'Chrome',
    title: 'Chrome Extension',
    description: 'Step-by-Step Guide to Install and Use MIRA Chrome Extension',
    href: 'https://chromewebstore.google.com/detail/mira-web-addin/pnmgejapnfgmfclcbnmnpfgllgklpaig',
    sources: [
      {
        title: '1. Open the Chrome Web Store 🔗',
        description: ['Go to the MIRA extension page on the Chrome Web Store.'],
      },
      {
        title: '2. Add MIRA to Chrome',
        description: [
          'Click the "Add to Chrome" button.',
          'Confirm by clicking "Add Extension" in the pop-up window.',
        ],
      },
      {
        title: '3. Pin the Extension (Optional but Helpful)',
        description: [
          'Click the puzzle piece icon in the top-right corner of Chrome.',
          'Find MIRA in the list and click the pin icon to keep it visible on your toolbar.',
        ],
      },
      {
        title: '4. Sign in',
        description: [
          'Click the MIRA icon in your toolbar.',
          'Sign in with Microsoft or Google.',
          'Enter your email and password.',
          'Grant any necessary permissions to allow MIRA to track your work hours.',
        ],
      },
      {
        title: '5. Start Tracking',
        description: [
          'Once logged in, MIRA will begin tracking your time spent on different websites and tasks.',
          'You can view reports, set goals, and manage your productivity directly from the extension',
        ],
      },
    ],
  },
  {
    orderBy: 2,
    key: 'edge',
    icon: EDGE_LOGO,
    label: 'Edge',
    title: 'Edge Extension',
    description: 'Step-by-Step Guide to Install and Use MIRA Edge Extension',
    href: 'https://microsoftedge.microsoft.com/addons/detail/mira-timekeeping-ai-web/dnfddokmnhjicbeklkhfklbffenpkhce',
    sources: [
      {
        title: '1. Open the Edge Web Store 🔗',
        description: ['Go to the MIRA extension page on the Edge Web Store.'],
      },
      {
        title: '2. Add MIRA to Edge',
        description: [
          'Click the "Add to Edge" button.',
          'Confirm by clicking "Add Extension" in the pop-up window.',
        ],
      },
      {
        title: '3. Pin the Extension (Optional but Helpful)',
        description: [
          'Click the puzzle piece icon in the top-right corner of Edge.',
          'Find MIRA in the list and click the pin icon to keep it visible on your toolbar.',
        ],
      },
      {
        title: '4. Sign in',
        description: [
          'Click the MIRA icon in your toolbar.',
          'Sign in with Microsoft or Google.',
          'Enter your email and password.',
          'Grant any necessary permissions to allow MIRA to track your work hours.',
        ],
      },
      {
        title: '5. Start Tracking',
        description: [
          'Once logged in, MIRA will begin tracking your time spent on different websites and tasks.',
          'You can view reports, set goals, and manage your productivity directly from the extension',
        ],
      },
    ],
  },
]
